export default "__VITE_ASSET__CRVOaFIK__"